import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter, Redirect } from 'react-router'
import WizardContainer from 'src/components/containers/wizard/WizardContainer'
import Box from 'src/components/containers/wizard/Box'
import ProgressBar, {
  ProgressBarContainerWizard
} from 'src/components/atoms/ProgressBar'
import Navigation from 'src/components/atoms/wizard/Navigation'
import Question from 'src/components/atoms/wizard/Question'
import FormContainer from 'src/components/containers/FormContainer'
import { RadioButton, RadioGroup } from 'src/components/atoms/input/RadioButton'
import { StoreProps } from 'src/stores'

interface State {
  valid: boolean
  noRedirect: boolean
}

@inject('wizardStore')
@observer
export class ProvisionReasonInput extends React.Component<StoreProps, State> {
  constructor(props) {
    super(props)
    const { wizardStore } = this.props
    const query = new URLSearchParams(location.search)
    this.state = {
      valid: !!wizardStore.provision.provisionReason,
      noRedirect: !!query.get('editor')
    }
  }

  componentDidMount() {
    window.dataLayer.push({ event: 'optimize.wizard_provisionReason' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.wizard_provisionReason' })
  }

  handleAnswerClick = (key) => {
    const { wizardStore } = this.props
    wizardStore.provision.provisionReason = key
    this.setState({ valid: true })
  }

  renderRadio = (label, name, value) => {
    const { wizardStore } = this.props
    return (
      <RadioButton
        label={label}
        name={name}
        value={value}
        defaultChecked={wizardStore.provision.provisionReason === value}
        onClick={() => this.handleAnswerClick(value)}
      />
    )
  }

  render() {
    const { wizardStore } = this.props
    const { valid, noRedirect } = this.state

    if (!wizardStore.basics.planningReason && !noRedirect)
      return <Redirect to='/planung/start/' />

    const radio1 = 'Ich möchte kostenlos und unverbindlich beraten werden.'
    const radio2 = 'Ich möchte gerne meine eigene Bestattung planen.'
    const radio3 = 'Ich möchte Preise für die Bestattungsvorsorge vergleichen.'
    return (
      <WizardContainer>
        <Box>
          <ProgressBarContainerWizard>
            <ProgressBar start={35} end={45} />
          </ProgressBarContainerWizard>
          <Question>Was ist der Grund für Ihre Anfrage?</Question>
          <FormContainer>
            <RadioGroup>
              {this.renderRadio(radio1, 'prov_reason', 'INFO')}
              {this.renderRadio(radio2, 'prov_reason', 'PLAN')}
              {this.renderRadio(radio3, 'prov_reason', 'COMPARE')}
            </RadioGroup>
          </FormContainer>
        </Box>
        <Navigation
          next={wizardStore.nextWizardStep}
          text='Weiter'
          disabled={!valid}
        />
      </WizardContainer>
    )
  }
}

export default withRouter(ProvisionReasonInput)



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/provision/ProvisionReasonInput.tsx